export default import.meta.ROLLDOWN_FILE_URL_J$xiWlR8TTtNtiB4XwZIUA